<template>
  <div v-loading="loading" class="page-wrap">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
          label-position="top"
          size="large"
          :model="form"
          :rules="rules"
          ref="formRef"
        >
          <el-row>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Tashabbuslar doskasi" prop="board_id">
                <el-select
                  v-model="form.board_id"
                  style="width: 100%"
                  placeholder="Doskani tanlang"
                >
                  <el-option
                    v-for="board in boards"
                    :key="board.id"
                    :value="board.id"
                    :label="board.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Yo'llar ro'yxatini yuklang" prop="file">
                <el-upload
                  ref="uploadRef"
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="uploadHeader"
                  :data="form"
                  :multiple="false"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  :limit="1"
                  :on-exceed="onExceed"
                  :before-upload="onBeforeUpload"
                  :on-success="onSuccessUpload"
                  :on-error="onErrorUpload"
                >
                  <template #trigger>
                    <el-button style="width: 100%" type="primary">
                      Excel faylni tanlang
                    </el-button>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18" :lg="16" :xl="14">
              <el-form-item label="Ro'yxatni yuklab olish">
                <el-button
                  class="upload-demo"
                  type="success"
                  @click="downloadExcel"
                >
                  <img
                    style="margin-right: 10px"
                    alt=""
                    src="@/assets/images/icons/download.svg"
                  />
                  Mavjud yo'llar ro'yxatini yulab olish
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";

export default {
  name: "RoadView",
  data() {
    return {
      loading: false,
      boards: [],
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/roads/sync-excel`,
      uploadHeader: { Authorization: `${this.$store.state.accessToken}` },
      form: {
        board_id: null,
      },
      rules: {
        board_id: [
          {
            required: true,
            message: "Tashabbuslar doskasini tanlang!",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    onBeforeUpload() {
      let isValid = this.$refs.formRef.validate((valid) => {
        this.loading = valid;
        return valid;
      });
      console.log("isValid", isValid);

      return isValid;
    },
    onSuccessUpload() {
      console.log("success upload");
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
    },
    onErrorUpload(error) {
      console.log("error upload", error.status);
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({ name: "Auth" });
      }
      ElNotification({
        title: "Xatolik",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "error",
      });
      this.loading = false;
    },
    getBoardList() {
      this.$http
        .get("api/v1/boards", { params: { status: 1 } })
        .then(({ data }) => {
          this.boards = data.boards;
        })
        .catch(() => {});
    },
    downloadExcel() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .get(`api/v1/roads/excel`, {
              responseType: "blob",
              params: this.form,
            })
            .then((res) => {
              const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
              );
              const header = res.headers.get("Content-Disposition");
              const parts = header.split(";");
              let fileName = parts[1].split("=")[1];
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            })
            .catch(({ response }) => {
              ElNotification({
                title: "Ogohlantirish",
                message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
                type: "warning",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
  },

  mounted() {
    this.getBoardList();
  },
};
</script>

<style scoped>
.page-wrap {
  padding: 20px;
}

.upload-demo,
.upload-demo:deep(.el-upload--text) {
  width: 100%;
}
</style>
